import React, { useState, ChangeEvent, useId, useContext } from "react";
import { Modal } from "../../components/Modal";
import { useModalHide } from "../../components/Modal";
import { useIsGuest } from "../../login/AuthContext";
import { FullReportEntry } from "../../models/FullReportEntry";
import { Column } from "../../table/Table";
import { AccountContext } from "../AccountContext";
import { AccountTableView } from "../AccountTableView";
import { DarkModeToogle } from "./dark-mode";
import { PrivacyToggle } from "./privacy-mode";


export function filterHiddenColumns(columns: Column<FullReportEntry>[], hidden:string[]){
    if(!hidden) return columns;
    return columns.filter(c => !hidden.includes(c.id))
}

export function isHidden(column: Column<FullReportEntry>, hidden:string[]){
    if(!hidden) return false;
    return hidden.includes(column.id)
}

function isHiddenCol(column: string, hidden:string[]){
    if(!hidden) return false;
    return hidden.includes(column)
}

export function ColumnToggle({column, on, toggle}:{column: Column<FullReportEntry>, on:boolean, toggle:(e:string)=>void}){
    const id = useId();
    return <div className="form-check my-3 column-input">
        <input className="form-check-input" type="checkbox" checked={on || false} onChange={() => toggle(column.id)} id={id} />
        <label className="form-check-label" htmlFor={id}>
            <span style={{pointerEvents:"none"}}>{column.label}</span>
        </label>
    </div>
}

export function ColumnsSettingsModal({columns}:{columns: Column<FullReportEntry>[]}){
    const {hiddenColumns, dispatch, tableMode} = useContext(AccountContext);

    function toggle(col:string){
        if(!hiddenColumns) 
            return dispatch({type: 'setHiddenColumn', payload: [col]});
        if(isHiddenCol(col, hiddenColumns))
            return dispatch({type: 'setHiddenColumn', payload: hiddenColumns.filter(c => c != col)});
        return dispatch({type: 'setHiddenColumn', payload: [...hiddenColumns, col]});
    }

    return <div className="column-settings-modal">
        <DarkModeToogle />
        <CustomGoalToggle />
        <SimpleModeToggle />
        <PrivacyToggle />
        {tableMode !== 'simple' && <p className="mt-3">Selecione as colunas que deseja tornar visíveis:</p>}
        {tableMode !== 'simple' && columns.map(c => {
            return <ColumnToggle key={c.id} column={c} on={!isHidden(c, hiddenColumns)} toggle={toggle}/>
        })}
        {tableMode !== 'simple' && <PrintModeButton /> }
    </div>
}

function SimpleModeToggle(){
    const {dispatch, tableMode} = useContext(AccountContext);
    const hide = useModalHide();
    let id = "simple-check";
    const isGuest = useIsGuest()
    if(isGuest) return null;

    async function onChange(){
        //await hide()
        dispatch({type: 'setTableMode', payload: tableMode == 'simple' ? true : 'simple'})
    }

    return <div className="form-check my-3">
        <input className="form-check-input" type="checkbox" checked={tableMode === 'simple'} onChange={onChange} id={id} />
        <label className="form-check-label" htmlFor={id}>
            Modo Simplificado
        </label>
    </div>
}

function CustomGoalToggle(){
    const {dispatch, customGoalMode} = useContext(AccountContext);
    const hide = useModalHide();
    let id = "custom-google-input";

    async function onChange(){
        await hide()
        dispatch({type: 'selectAccount', payload: null})
        dispatch({type: 'setGoalMode', payload: !customGoalMode})
    }

    return <div className="form-check my-3">
        <input className="form-check-input" type="checkbox" checked={customGoalMode} onChange={onChange} id={id} />
        <label className="form-check-label" htmlFor={id}>
            Usar Metas Personalizadas
        </label>
    </div>
}

function PrintModeButton(){
    const {dispatch} = useContext(AccountContext);
    const printColumns = [
        "franchise",
        "manager",
        "missingDays",
        "monthGoal",
        "goalA",
        "suggestedBudget",
        "overrun",
        "projection",
        "trend"
    ]

    function turnPrintMode(){
        dispatch({type:"setHiddenColumn", payload: printColumns})
    }

    return <div className="mt-3">
            <button className="btn btn-info" onClick={turnPrintMode}>Modo Print</button>
        </div>
}


export function ColumnSettingsButton({columns}:{columns: Column<FullReportEntry>[]}){
    const [show, setShow] = useState(false);
    return <>
        <button className="btn-link btn d-print-none" onClick={() => setShow(true)}><i className="fa fa-cog"></i></button>
        {show && <Modal title="Configurações" onHide={() => setShow(false)}><ColumnsSettingsModal columns={columns} /></Modal>}
    </>
}